export default __webpack_public_path__ + "static/media/bearerOfFruit2.07bcfa68.png";